<template>
  <tr>
    <a v-if="icon" style="text-decoration: none; color: inherit;" :href="link" target="_blank">
      <th class="p-2 ps-2"><img v-if="icon" :src="icon" alt="Icon" width="24" height="24" class="bi me-2">{{ name }}</th>
    </a>
    <th v-else class="ps-2">{{ name }}</th>
    <td v-if="link" class="pe-2"><a :href="link" target="_blank">{{ value }}</a></td>
    <td v-else class="pe-2">{{ value }}</td>
  </tr>
</template>

<script>
export default {
  name: "DevicePageEntry",
  props: {
    "name": String,
    "value": String,
    "link": String,
    "icon": String,
  }
}
</script>

<style scoped>
th {
  width: 50%;
}
td {
  text-align: right;
  width: 50%;
}
tr:hover {
  background-color: #fcfcfc;
}
</style>